import { sendAjaxDataToWP } from "./sendAjaxDataToWP";
import { createToast } from "./Toast";
import { delay } from "./Utils";

const CreateRatingObjectives = (modal, editor) => {


  function getQueryParam(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  let url = document.URL;

  const activeTabId = getQueryParam("tab");
  if (activeTabId) {
    url = document.URL;
  } else {
    url = `${document.URL}&tab=progression`;
  }

  const form = document.getElementById("add_rating_objectives_form");

  if (form) {
    const spinner = form.querySelector("button[type=submit] svg");
    const spinnerText = form.querySelector("button[type=submit] span");

    form.addEventListener("submit", (ev) => {
      ev.preventDefault();

      // show spinner
      spinner.classList.remove("hidden!");
      spinnerText.textContent = "Saving...";

      // create form data
      const data = new FormData(form);
      data.append("action", "add_rating_objectives");
      data.append("objectives", editor.getContents());

      // update via ajax
      sendAjaxDataToWP(data)
        .then((result) => {
          if (result) {
            //console.log("Data received from server:", result);
          }
          delay(1000).then(() => {
            spinner.classList.add("hidden!");
            spinnerText.textContent = "Save";
            createToast({
              type: "success",
              message: result.message,
              duration: 1000,
              url: url
            });
            modal.hide();
          });
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
          spinner.classList.add("hidden!");
          spinnerText.textContent = "Save";
          createToast({
            type: "error",
            message: "Cannot update rating objectives",
            duration: 1000,
          });
        });
    });
  }
};

export { CreateRatingObjectives };
